<script setup>
import { computed, onMounted } from "vue";
import WaitlistServices from "@/api/actions/waitlist-service";
import BaseIcon from "@/library/BaseIcon.vue";
import store from "@/store";

onMounted(() => {
  WaitlistServices.getWaitlist();
});

const heimdallWaitlistActive = computed(
  () => store.getters.heimdallWaitlistActive
);

const heimdallWaitlist = computed(() => {
  const waitlist = store.state.waitlist.waitlist;
  return waitlist.find((item) => item.internal_name === "heimdall") || {};
});

function joinWaitlist() {
  WaitlistServices.joinWaitlist({ waitlist_id: heimdallWaitlist.value.id });
}
</script>

<template>
  <div
    v-if="heimdallWaitlistActive"
    class="call-guard-waitlist"
  >
    <div class="call-guard-waitlist__content">
      <h2 class="call-guard-waitlist__title">
        <BaseIcon
          name="phone"
          class="call-guard-waitlist__title-icon"
        />
        <span>Coming Soon: Call Guard</span>
      </h2>
      <p
        v-if="heimdallWaitlist?.joined_at === null"
        class="call-guard-waitlist__description"
      >
        Let our AI assistant answer your calls first. It blocks the spam and
        only lets through the calls that matter to you.
      </p>
      <p
        v-else
        class="call-guard-waitlist__description"
      >
        🎉 You’re on the list! We’ll let you know as soon as Call Guard is
        available.
      </p>
      <button
        class="call-guard-waitlist__button"
        :class="{
          'call-guard-waitlist__button--disabled':
            heimdallWaitlist?.joined_at !== null,
        }"
        @click="joinWaitlist"
      >
        Join waitlist for early access
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.call-guard-waitlist {
  background: $color-primary-1;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 16px 20px 0 rgba($black, 0.05);
  width: 100%;
  border: 1px solid $color-primary-10;
  display: flex;
  flex-direction: column;

  &__title {
    color: $color-primary-100;
    font-size: 15px;
    font-weight: 600;
    line-height: 22.5px;
    position: relative;
    padding-left: 26px;

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-right: 8px;
      position: absolute;
      top: 50%;
      left: 0;
      @include transform(translateY(-50%));
    }
  }

  &__description {
    color: $color-primary-70;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-top: 8px;
  }

  &__button {
    background: $cloaked-gradient;
    color: $color-primary-1-light;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    width: 100%;
    display: block;
    box-shadow: 0 4px 10px rgba($black, 0.1);
    transition: background 0.3s ease;
    margin-top: 12px;

    &:hover {
      cursor: pointer;
      box-shadow: 0 5px 5px 0 rgba($color-primary-100-light, 0.1);

      @at-root .theme-dark & {
        box-shadow: 0 5px 5px 0 rgba($color-primary-100-dark, 0.1);
      }
    }

    &--disabled {
      transform: none;
      box-shadow: none;
      transition: none;
      opacity: 0.3;
      pointer-events: none;
      background: $color-primary-30;
      color: $color-primary-100;
    }
  }
}
</style>
